import type { Rect } from '../../../engine/hex/types';
import type { Painter, TextAlign } from './Painter';

export class CanvasPainter implements Painter {
    constructor(private ctx: CanvasRenderingContext2D) {}

    measureText(text: string, font: string): number {
        const previous = this.ctx.font;
        this.ctx.font = font;
        const width = this.ctx.measureText(text).width;
        this.ctx.font = previous;
        return width;
    }

    panel(rect: Rect, fill: string, stroke: string): void {
        this.ctx.fillStyle = fill;
        this.ctx.strokeStyle = stroke;
        this.ctx.lineWidth = 1;
        this.ctx.beginPath();
        this.ctx.rect(rect.x, rect.y, rect.w, rect.h);
        this.ctx.fill();
        this.ctx.stroke();
    }

    button(rect: Rect, fill: string, stroke: string): void {
        this.panel(rect, fill, stroke);
    }

    text(
        text: string,
        x: number,
        y: number,
        color: string,
        font: string,
        align: TextAlign = 'left',
    ): void {
        this.ctx.fillStyle = color;
        this.ctx.font = font;
        this.ctx.textBaseline = 'top';
        this.ctx.textAlign = align;
        this.ctx.fillText(text, x, y);
    }

    image(image: HTMLImageElement, rect: Rect): void {
        this.ctx.drawImage(image, rect.x, rect.y, rect.w, rect.h);
    }

    progressBar(
        rect: Rect,
        ratio: number,
        trackFill: string,
        trackStroke: string,
        fill: string,
    ): void {
        this.ctx.fillStyle = trackFill;
        this.ctx.strokeStyle = trackStroke;
        this.ctx.beginPath();
        this.ctx.rect(rect.x, rect.y, rect.w, rect.h);
        this.ctx.fill();
        this.ctx.stroke();
        if (ratio <= 0) return;
        const clamped = Math.min(1, Math.max(0, ratio));
        this.ctx.fillStyle = fill;
        this.ctx.fillRect(rect.x, rect.y, rect.w * clamped, rect.h);
    }

    dot(x: number, y: number, radius: number, color: string): void {
        this.ctx.fillStyle = color;
        this.ctx.beginPath();
        this.ctx.arc(x, y, radius, 0, Math.PI * 2);
        this.ctx.fill();
    }
}
